<div [class]="'liquid-glass-container ' + containerClass">
  <div class="liquid-background">
    <div class="liquid-shape shape-1"></div>
    <div class="liquid-shape shape-2"></div>
  </div>
  <ng-content/>
</div>
